import { match } from 'ts-pattern';
import { makeShippingProtectionClaimLoader, redirect } from '~/utils/routing';
import { claimAddressSchema } from '~/utils/schemas';

export const { loader, useLoaderData } = makeShippingProtectionClaimLoader(
  (
    {
      context: {
        shippingProtectionClaim: { address },
        order,
      },
    },
    appStore,
  ) =>
    match(claimAddressSchema.safeParse(address ?? order.shippingAddress))
      .with({ success: true }, ({ data }) => {
        appStore.dispatch(
          appStore.actions.shippingProtectionClaim.setAddress(data),
        );

        return data;
      })
      .with({ success: false }, () => redirect('edit'))
      .exhaustive(),
);
